export const it = {
  type: "it",
  code: "it-it",
  name: "Italiano",
  img: "flag-icon-it",
  pages: {
    login_main_navigation: {
      login: {
	pageName: 'accedi',
	callback: 'Chiudi questa finestra e continua nel componente aggiuntivo di Tribeloo per Outlook',
	email_dialog: {
	  header: 'Inserisci il tuo indirizzo e-mail',
	  input: 'E-mail'
	},
	sso_info:{
	  text: "Il tuo browser sta bloccando l'apertura di una nuova scheda per accedere tramite SSO. Modifica le impostazioni del tuo browser oppure clicca sul pulsante 'Forza apertura'",
	  button: "Forza apertura"
	},
	text: {
	  loading: ['Stiamo lavorando per te', 'Se l\'attesa è troppo lunga,', 'ricarica la pagina'],
	  header: 'Benvenuto',
	  sub_header: 'Prenota le tue scrivanie preferite, trova i tuoi colleghi e molto altro.',
	  form_headers: {
	    login: 'Accedi',
	    email: 'Verifica l\'indirizzo e-mail',
	    password: 'Password dimenticata?'
	  },
	  password_info: ["Non preoccuparti! Ti invieremo un link di recupero.", 'Una nuova password è stata inviata al tuo indirizzo e-mail.'],
	  inputs: ['Nome utente', 'Password', 'E-mail'],
	  remember_action: ['Ricordami.', 'Non sei tu?', 'Password dimenticata?', 'Torna all\'accesso'],
	  button: ['Accedi con SSO', 'Accedi', 'Reimposta password'],
	  info_modal: 'Controlla la tua e-mail per cambiare la password'
	}
      },
      delegates_modal: {
	header: "Seleziona profilo delegato",
	sub_header: "Seleziona la persona per cui desideri effettuare una prenotazione",
	button_select: "Seleziona"
      },
      main_navigation: {
	pageName: "Navigazione laterale, componente della barra degli strumenti principale",
	nav_tabs_names: {
	  user: "Utente",
	  admin: "Amministratore"
	},
	nav_dropdown_corg: {
	  about: 'Informazioni',
	  history: "Cronologia",
	  feedback: 'Invia feedback',
	  logout: 'Esci',
	  user_settings: "Impostazioni utente",
	  delegate: "Cambia profili delegati",
	  user: "Passa al profilo utente",
	  admin: "Passa al profilo amministratore"
	},
	admin_nav_items: {
	  dashboard: "Dashboard",
	  reservation_management: "Gestione prenotazioni",
	  newsfeed: "Notizie",
	  user_management: "Gestione utenti",
	  site_configuration: "Configurazione del sito",
	  kiosk_configuration: "Configurazione del chiosco",
	  issue_management: "Gestione dei problemi",
	  insights: "Statistiche"
	}
      }
    },
    external: {
      close_issue_by_hash: "Grazie per aver chiuso questo problema!!",
      hash_reservation: "Prenotazione non disponibile",
      google: "Caricamento in corso...",
      outlook_reservation: {
	popup: 'Eliminare questa prenotazione?',
	login: "Accedi",
	no_space_info: [ "Nessuno spazio prenotato,", "Si prega di contattare l'organizzatore della riunione" ],
	site_headr: "Posizione del sito",
	date_time: "Ora mostrata nel fuso orario della località richiesta/FUSO ORARIO",
	space: {
	  header: "Spazio",
	  internal_external: [ "interno ", "esterno " ]
	},
	amenities_header: "Servizi"
      },
      reset_password: {
	info_modal: "Password modificata",
	button_update: "Aggiorna password",
	placeholders: [ "Inserisci nuova password", "Reinserisci nuova password" ],
	errors: [ "La password non soddisfa i requisiti minimi", "Le password non corrispondono" ],
	rules: "La password deve contenere almeno: 8 caratteri, 1 maiuscola, 1 minuscola, 1 cifra"
      }
    },
    kiosk: {},
    admin: {
      kiosk: {
	main_header: 'Set up a kiosk',
	card: {
	  headers: {
	    site: 'Select a site',
	    wing: ['Select a wing ', '(optional)']
	  },
	  placeholders: {
	    site: 'Please search or select a site',
	    wing: 'Please search or select a wing'
	  },
	  warning: 'Not running in kiosk, PWA or full-screen mode.',
	  button: 'Launch kiosk mode',
	},
	info: {
	  kiosk: 'For Kiosk - please logout, close browser and than run a following command: ',
	  pwa: 'For PWA or full-screen browser - use Google chrome browser and',
	  button: 'Click here'
	}
      },
      dashboard: {
	main: {
	  refresh: "Refresh",
	  site_card: {
	    header: " Dashboard",
	    action: "Help center",
	    sub_header: "Select a site to get an overview"
	  },
	  small_card: {
	    header: " Meeting rooms",
	    total: "TOTAL",
	    assigned: "Assigned"
	  },
	  utilization_cards: {
	    header: " Max utilization rate ",
	    special_header: "Max utilization rate special types",
	    tooltip: "The max utilization rate is the max ratio during that day of requested over available resources of the selected type",
	    table: {
	      headers: [
		{ name: "All types", tag_name: "all_types" },
		{ name: "Desks", tag_name: "desks" },
		{ name: "Meeting rooms", tag_name: "rooms" },
		{ name: "Meeting rooms - Large ", tag_name: "big_rooms" },
		{ name: "Meeting rooms - External", tag_name: "external" },
		{ name: "Released %", tag_name: "releases" },
	      ],
	      hover: ["Requested ", "Available "]
	    },
	    info: "Click on a number in the table to see the chart",
	    zoom: ['zoom out', 'zoom in']
	  },
	  to_do_card: {
	    header: " To-do’s",
	    link: "Go to to-do list",
	    table: [
	      { name: "To be confirmed", tag_name: "to_be_confirmed" },
	      { name: "To be assigned", tag_name: "to_be_assigned" },
	      { name: "Untreated request", tag_name: "with_message" },
	      { name: "Total", tag_name: "total" }
	    ]
	  },
	  not_enough_card: {
	    header: "Not enough resources",
	    info_default: "Click on a number in the table to see the solutions.",
	    info_selected: "Let’s see how we can solve this.",
	    button_reservation: "Remind people about their reservations",
	    button_release: "Request more releases"
	  }
	},
	releases_table: {
	  info: "You can ask people who have not released their resource for this day to release it.",
	  headers: {
	    user: { popup: 'owners', name: "Assigned to" },
	    level: { popup: 'Level of user', name: "Level assigned user" },
	    wing: { popup: 'Wings', name: "Wing" },
	    space: { popup: 'Resource', name: "Resource" },
	    asset_level: { popup: '', name: "Asset level" },
	    seat: { popup: '', name: "Seat capacity" },
	    amenities: { popup: '', name: "Resource’s amenities" }
	  },
	  tooltip: "send message to all",
	  dialogues: {
	    send_all_message: "Send message to all selected releases?",
	    select_owner_message: "At least one user must be selected.",
	    error_message: "Error sending",
	  }
	},
	reservations_table: {
	  info: "You can remind people who have a reservation for this day to cancel their reservation if no longer needed.",
	  headers: {
	    user: { popup: 'Owners', name: "User" },
	    level: { popup: 'Level', name: "Level of user" },
	    subject: { popup: '', name: "Subject" },
	    from: { popup: '', name: "From" },
	    to: { popup: '', name: "To" },
	    rc: { popup: 'Requested seats', name: "Requested seats" },
	    ie: { popup: 'internal external', name: "internal/ external" },
	    amenities: { popup: '', name: "Requested amenities" },
	    wing: { popup: 'Wings', name: "Wing" },
	    space: { popup: 'Resource', name: "Resource" },
	    status: { popup: 'Statuses', name: "Status" }
	  },
	  tooltip: "send message to all",
	  dialogues: {
	    send_all_message: "Send message to all selected reservations?",
	    select_owner_message: "At least one user must be selected.",
	    error_message: "Error sending",
	  }
	}
      },
      newsfeed: {
	navigation: ['Newsfeed', 'Emergency message'],
	list: {
	  main_header: 'Newsfeed',
	  site_header: 'Select a site to check its newsfeed.',
	  i_tooltipe: 'The newsfeed of a site is shown on the homepage for all sites selected by the user',
	  card: {
	    header: 'Settings',
	    toggle: 'Show newsfeed of site',
	    i_tooltipe: 'You can choose to show the newsfeed of another site',
	    select: {
	      toggle: 'Click here to select the site',
	      placeholder: 'Select site'
	    },
	    auto_remove: {
	      text: ['Automatically delete news items that are older than ', ' days. '],
	      i_tooltipe: 'Choose how long news items are shown on the newsfeed before they get deleted. Events are removed from the newsfeed once ended.'
	    }
	  },
	  add_item: ' Add new item',
	  popups: {
	    info: 'Please select a location!',
	    confirm: 'Delete all existing newsitems and events of ',
	    button: 'OK'
	  }
	},
	form: {
	  main_header: 'Emergency message ',
	  site_header: 'Select a site for which you want to write an emergency message.',
	  i_tooltipe: 'An emergency message, once turned on, is visible for all users of that site on the Tribeloo homepage and on the devices of that site',
	  message: "Haven't message",
	  placeholder: 'Emergency message line ',
	  save: 'Save',
	  emergency: ['Turn on emergency message', 'Turn off emergency message']
	}
      },
      site_config: {
	navigation: {
	  site: "Site configuration",
	  rules: "Site rules",
	  table: "Resource configuration table",
	  types: "Resource types",
	  wayfinding: "Wayfinding"
	},
	edit_site: {
	  header: "Editing site ",
	  video_header: "How to add, edit and delete a site",
	  buttons: {
	    add: "Add new site",
	    delete: "Delete site"
	  },
	  toggle: "Site is active & visible for users",
	  toggle_warning: ["Site is currently ", "inactive & invisible"," for users"],
	  base: {
	    header: "Basic details",
	    video_header: "How to set up a site: basic details",
	    placeholder: {
	      name: "site name",
	      code: "plus code",
	      address: "address of this site"
	    },
	    label: {
	      code: "Define coordinates of site (plus code) ",
	      address: "Address of site "
	    },
	    tooltip: {
	      code: "Plus code can be found on Google maps and is used to show a map of the location on the wayfinding link",
	      address: "Address is shown on the wayfinding link"
	    },
	    position: {
	      header: "Position of wing",
	      info: "Select a wing, by clicking on its title, to change its position.",
	    },
	  },
	  amenities: {
	    header: "Amenities",
	    video_header: "How to set up a site: amenities",
	    info: "Define amenities ",
	    tooltip: "Amenities are additional features, like a beamer or a flipchart, which can be selected when looking for a resource. Select amenities in the list below, to activate them on the current site, so they can be assigned to a specific resource from this site.",
	    counter: [" in total - ", " active"],
	    placeholder: "new amenity"
	  },
	  manager: {
	    header: "Site manager settings",
	    video_header: "How to set up a site: site manager settings",
	    info: "Add e-mail address office manager ",
	    tooltip: "Office manager will receive emails when new issues are reported ",
	    placeholder: "e-mail",
	    toggle: ["Send email to-do's every ", "hours"],
	  },
	  device: {
	    header: "Device settings",
	    video_header: "How to set up a site: device settings",
	    label: {
	      time: "Use 24h time for devices ",
	      password: "Device password (0-9 A-E) "
	    },
	    tooltip: {
	      time: "Select time format for meeting room and desk devices: AM/PM or 24h format",
	      password: "Password used to access configuration screen on devices"
	    },
	    placeholder: "code 0-9 A-E"
	  },
	  insights: {
	    header: "Insight settings",
	    video_header: "How to set up a site: insight settings",
	    labels: {
	      days: "Define working days ",
	      hours: "Define working hours ",
	      room: ["Define a large meeting room", "people or more"],
	    },
	    tooltip: {
	      days: "Working days are used to calculate average utilization rate in insights",
	      hours: "Working hours are used to calculate average utilization rate in insights"
	    },
	    range: ["from", "to"]
	  },
	  popups: {
	    online: {
	      text: 'Bring this site online?',
	      descriptions: ['This will make the site visible for regular users and ready for reservations.']
	    },
	    offline: {
	      text: 'Bring this site offline?',
	      descriptions: ['This will make the site invisible for regular users. Existing reservations will be kept.']
	    },
	    delete_site: {
	      text: 'Delete this site?',
	      big_descriptions: ['This will delete all wings, resources and reservations for this site. \nUsers with this home site will be moved to having no home site.']
	    },
	    cant_delete_site: 'Site can not be deleted.',
	    amenity: {
	      exists: 'Amenity already exists.',
	      cant_updated: 'Amenity cannot be updated. Used by resources on other sites.',
	      cant_delete: 'Amenity cannot be deleted, because it is assigned to some resources.',
	      cant_disabled: 'Amenity cannot be disabled, because it is assigned to some resources. Remove it first from all resources.'
	    }
	  },
	  edit_amenity_dialog: "Edit amenity",
	  edit_wings_sorted: {
	    add_button: " Add Wing",
	    position: "Position: ",
	  },
	  wing_position: {
	    header: "Selected wing: ",
	    position: "Position ",
	    move: "Move to position "
	  }
	},
	rules: {
	  header:"Site rules",
	  site_card: {
	    header: "Site",
	    sub_header: "Select a site for which you want to define user privileges and rules."
	  },
	  default_reservation_time_card: {
	    header: "Default reservation time",
	    sub_header_desk: "Desk",
	    sub_header_room: "Meeting room",
	    label_start: "Start date",
	    label_end: "Duration"
	  },
	  auto_assign_card: {
	    header: "Auto-assign resources ",
	    video_header: 'How to auto-assign resources to reservations',
	    sub_header: "Reservations can get a resource auto-assigned if the user requests one, if none is available it will appear in the to-do list of the office manager",
	    toggle: "Activate auto-assign functionality for ‘to assign’ reservations",
	  },
	  check_in_reminder_email_card: {
	    header: "Check-in reminder email ",
	    video_header: 'How to use the check-in reminder emails & auto-cancel reservations',
	    send_toggle: "Send out reminder email 15 minutes before the start of a reservation that requires check-in",
	    add_button_toggle: ["Add ", "‘Cancel reservation’", " button to reminder email"],
	    add_desck_toggle: ["For ", "desk", " reservations: add ", "‘Check-in’", " button to reminder email"],
	    add_room_toggle: ["For ", "meeting room", " reservations: add ", "‘Check-in’", " button to reminder email"],
	    auto_cancel_header: "Auto-cancel reservations that require check-in",
	    cancel_desk_toggle: ["Cancel ", "desk", " reservation after", "min, if a check-in is required."],
	    cancel_room_toggle: ["Cancel ", "meeting room", " reservation after", "min, if a check-in is required."],
	  },
	  reminder_email_card: {
	    header: ["Reminder email", "for desks"],
	    video_header: 'How to use the general reminder emails',
	    send_toggle: ["Send reminder email ", "hours before the start of a reservation"],
	    subject: {
	      label: "Subject:",
	      placeholder: "Reminder about your upcoming reservation"
	    },
	    message: {
	      label: ["Message: (Markdown supported, for example to add links. ", "Check guidelines"],
	      placeholder: "Add message"
	    },
	    agree_toggle: ["Add ", "‘I agree’", " button: by agreeing the person acknowledges they have read the message"],
	    cancel_toggle: ["Add ", "‘Cancel reservation’", " button"],
	    header_special: "Reminder email for meeting rooms",
	    send_toggle_special: ["Send reminder email ", "hours before the start of a reservation"]
	  },
	  time_limit_card: {
	    header: "Time limit for future reservations",
	    video_header: 'How to use the time limit for future reservations',
	    sub_header: "Reservations can only be made a certain time ahead by non-admin users",
	    desck_toggle: ["Desk", " reservations can be created in the next"],
	    room_toggle: ["Meeting room", " reservations can be created in the next"],
	    special_toggle: "Reservations can be created in the next",
	    postfix: "working days"
	  },
	  utilization_limit_card: {
	    header: "Utilization limit",
	    sub_header: ["Utilization of active ", " can be limited.", "Example: a site has 40 active ", ". When utilization is limited to 50%, only 20 concurrent ", " reservations can be made."],
	    sub_header_types: ['desks', 'resources', 'desk'],
	    toggle: ["Utilization is limited to", "percent"]
	  },
	  multi_day_reservation_card: {
	    header: "Multi-day reservation",
	    sub_header: ["Define if an employee is allowed to create one reservation for several consecutive days at once.", "When allowed, an employee will only receive the reminder emails once and only needs to check-in once at the start of his multi-day reservation, if this is required."],
	    toggle: "Multi-day reservations are allowed"
	  },
	  cleaning_time_card: {
	    header: "Cleaning",
	    sub_header: "Cleaning time will be foreseen after the end of every reservation. During this period the resource cannot be booked.",
	    desk_toggle: ["Time available to clean a ", "desk", "min"],
	    room_toggle: ["Time available to clean a ", "meeting room", "min"]
	  },
	  user_message_card: {
	    header: "User message when creating reservation ",
	    toggle: 'Show this message when a user creates a reservation for a resource on this site',
	    label: 'Message:',
	    placeholder: 'Type your message here',
	  },
	  user_privileges_card: {
	    header: "User privileges",
	    video_header: 'How to set up user privileges',
	    sub_header: "Define which users have access to which resources and have to get confirmation for a reservation",
	    levels: {
	      header: "1. Define the names of the different user levels and resource levels:",
	      toggle: "User level names are the same across all sites",
	      description_simple: {start: "User & resource level names", center: " can be set by site admin and are ", end: "specific for the site."},
	      description_global: [
		{start: "User level names", center: " can only be set by global admin and are the ", end: "same for all sites."},
		{start: "Resource level names", center: " can be set by site admin and are ", end: "specific for the site."},
	      ],
	      user_label: "User level ",
	      resource_label: "Resource level ",
	      placeholder: "Text"
	    },
	    privileges: {
	      header: "2. Define the privileges per user and resource level:",
	      cols: "Resource level",
	      rows: "User level"
	    },
	    rules: [
	      {id: 0, line1: "Resource not available", line2: "(can be assigned by admin)", class: "red"},
	      {id: 2, line1: "Resource only available ", line2: "after confirmation", class: "orange"},
	      {id: 1, line1: "Resource available for", line2: "user level", class: "green"}
	    ]
	  },
	},
	edit_wing: {
	  header: "Editing wing ",
	  sub_header: "wing details",
	  video_header: "How to add, edit and delete a wing",
	  placeholder: "wing name",
	  button: {
	    back: "Back to site edit",
	    add: "Add new wing",
	    delete: "Delete wing"
	  },
	  popup: {
	    text: 'Delete this wing?',
	    big_descriptions:['This will delete all resources of this wing and could affect current reservations. \nCheck your to-do list if proceeding.']
	  },
	  assets_list: {
	    header: "Resources",
	    add_button: " Add resource",
	    counter: " in total",
	    popup: {
	      text: 'Delete this resource?',
	      big_descriptions:['This could affect current reservations. \nCheck your to-do list if proceeding.']
	    }
	  }
	},
	edit_asset: {
	  buttons:{
	    back: "Back to wing edit",
	    add: "Add resource",
	    clone: "Duplicate resource",
	    delete: "Delete resource"
	  },
	  base: {
	    header: "Basic details ",
	    video_header: "How to add, edit and delete a resource & define the basic details",
	    internal_external: [
	      {name:"Internal only", value: true},
	      {name:"External allowed", value: false}
	    ],
	    type_tooltipe: 'INTERNAL ROOM: used for a meeting with colleagues from within the company.\n EXTERNAL ROOM: used when also people of outside the company are invited (e.g. client).\n ZONE: contains multiple single desks that can be booked, without selecting a particular one.',
	    user_tooltipe: 'Assigning a resource to a specific person, means that this person has a fixed desk and they alone can use it. They can still choose to release it for others to use, when they aren’t around.',
	    zoning_tooltipe: 'Semicolon separated list of zoning names, useful for HVAC/BM integration.\n E.g.:\n lighting_7;heating_3',
	    amenity_type: "other asset type",
	    placeholders: {
	      name: "asset name",
	      user: "Select user",
	      neighbourhood: "Select neighbourhood",
	      amenities: "Select amenities"
	    },
	    labels: {
	      status: "Resource status ",
	      neighbourhood: "Neighbourhood ",
	      user: "Assigned to ",
	      level: "Resource level ",
	      resource_zoning: "Resource zoning ",
	      capacity: ['Seat capacity', 'Capacity'],
	      type: "Resource type ",
	      check_in: "Check-in required",
	      amenities: "Amenities available ",
	      image: "Add image (< 4MB)"
	    }
	  },
	  size: {
	    header: "Size, Shape & position ",
	    video_header: "How to set up a resource: size, shape & position",
	    size: {
	      header: "Size & shape",
	      sub_header: "Choose a shape",
	      width: "Width",
	      height: "Height",
	      round: "Round corners"
	    },
	    position: {
	      header: "Map position",
	      horizontal: "Horizontal",
	      vertical: "Vertical"
	    }
	  },
	  calendar: {
	    header: "Calendar & approval settings",
	    video_header: "How to set up a resource: calendar & approval settings",
	    resource: {
	      label: "Resource email ",
	      placeholder: "Resource email",
	      tooltip:"Fill in an email to create a calendar for this resource. Tribeloo will keep the calendar up to date with reservations for this resource."
	    },
	    approvers: {
	      label: "Approvers email ",
	      placeholder: "Approvers email",
	      tooltip:"Add the email address of the person who will confirm reservations for this resource. Multipe email addresses can be added separated by a semicolon ; and without any spaces before or after the semicolon"
	    },
	  },
	  device: {
	    header: "Device configuration",
	    video_header: "How to set up a resource: device configuration",
	    code: {
	      label: "Device code ",
	      placeholder: "Code"
	    },
	    id: {
	      label: "Device ID ",
	      placeholder: "ID"
	    }
	  },
	  qr_nfc: {
	    header: "QR & NFC configuration",
	    video_header: "How to set up a resource: QR & NFC configuration",
	    qr: {
	      header: "Generate QR code",
	      info: "Click on the button to generate a QR code of this resource.",
	      button: "Generate QR"
	    },
	    nfc: "NFC configuration"
	  },
	  popups: {
	    nfc_copy: "NFC url copied.",
	    set_capacity: {
	      text: 'Reduce seat capacity?',
	      big_descriptions: ['This could affect current reservations. \nCheck your to-do list if proceeding.']
	    },
	    select_owner: {
	      text: 'Assign user to resource?',
	      big_descriptions: ['This could affect current reservations. \nCheck your to-do list if proceeding.']
	    },
	    internal_change: {
	      text: "Change resource type to ‘Internal only’?",
	      big_descriptions:["This could affect current reservations. \nCheck your to-do list if proceeding."]
	    },
	    remove: {
	      text: 'Delete this resource?',
	      big_descriptions:['This could affect current reservations. \nCheck your to-do list if proceeding.']
	    },
	    check_card_id: {
	      header: "",
	      cases: [
		'1. Click "Start test" below',
		'2. On selected device, tap "Book now" or "Book later"',
		'3. Scan your card on the device',
		'4. The RFID code of the scanned card appears below',
		'5. To test another card, go to step 2'
	      ],
	      start: "Start test",
	      stop: "Stop"
	    }
	  },
	  assets_dragging_view: [" - click for edit", "drag & drop", "click to select"]
	},
	edit_info: {
	  create: "Created on: ",
	  update: "Last updated on: ",
	  resource: "Resources: ",
	},
	type: {
	  header: "Resource types",
	  sub_header_descriprion: {
	    first_line: "Standard sites have the type 'room or desk' automatically assigned.",
	    second_line: ["If you want to create sites that contain another type of resource, define them here.", "These other resource types will also become visible on the Tribeloo homepage and in the tab 'More' in Outlook."]
	  },
	  video_header: 'How to define different resource types to book',
	  card: {
	    list: {
	      header: "Existing resource types",
	      button: "Add new resource type"
	    },
	    form: {
	      header: ["Create resource type", "Edit resource type"],
	      type: {
		label: "Resource type",
		placeholder: "Name of resource type"
	      },
	      icon: {
		label: "Icon",
		placeholder: "fa fa-archive",
		button: "Check icon list"
	      },
	      preview: {
		label: "Preview",
		text: ["Book a ", "Book a desk", "Book a meeting room"]
	      },
	      booking: {
		label: "Double booking by user",
		sub_label: "(desks only)"
	      },
	      button: {
		create: " Create type",
		delete: " Delete type",
		save: " Save changes",
	      }
	    }
	  },
	  popups: {
	    unique_name: "You already have a type with the same name",
	    create: 'Create type?',
	    save: 'Save changes?',
	    add: "New resource type is added",
	    saved: "Changes saved",
	    delete: 'Delete this resource type?',
	    cant_delete: "This resource can't be deleted, because there are still sites of this type"
	  },
	},
	assets_table: {
	  buttons: {
	    batch: "Batch edit",
	    qr: ["QR PDF selected", "QR PDF all"]
	  },
	  headers: {
	    number: {name: "Number", popup: ""},
	    resource: {name: "Resource", popup: ""},
	    wing: {name: "Wing", popup: "Wings"},
	    user: {name: "Assigned to", popup: ""},
	    level: {name: "Resource level", popup: "Resource level"},
	    neighbourhood: {name: "Neighbourhood", popup: "Neighbourhood"},
	    capacity: {name: "Seat capacity", popup: "Seat capacity"},
	    type: {name: "Resource type", popup: "Resource type"},
	    check_in: {name: "Check-in required", popup: "Check-in required"},
	    amenities: {name: "Amenities", popup: ""},
	    device_id: {name: "Device ID", popup: ""},
	    email: {name: "Resource email", popup: ""},
	    status: {name: "Status", popup: "Status"},
	    from: {name: "From", popup: ""},
	    to: {name: "To", popup: ""}
	  },
	  popups: {
	    batch: {
	      header: "Edit resource details",
	      sub_header: "Update",
	      level: "Resource level",
	      capacity: "Seat capacity",
	      type: {
		label: "Resource type",
		values: [
		  { name: 'Internal only', value: true },
		  { name: 'External allowed', value: false }
		],
	      },
	      check_in: {
		label: "Check-in required",
		values: [
		  { name: 'yes', value: true },
		  { name: 'no', value: false }
		],
	      },
	      add_amenities: {
		label: "Add amenities",
		placeholder: "Select amenities"
	      },
	      remove_amenities: {
		label: "Remove amenities",
		placeholder: "Select amenities"
	      },
	      approvers: {
		label: "Set approvers",
		placeholder: "approvers email"
	      },
	      neighbourhood: {
		label: "Neighbourhoods",
		placeholder: "Select neighbourhood"
	      },
	      status: "Resource status"
	    },
	    selected: "At least one resource must be selected",
	    selete_selected: ["Delete the ", " selected resources?"],
	    this_delete: "Delete this resource?"
	  }
	},
	wayfinding_link: {
	  header: "Wayfinding link",
	  privacy_card: {
	    header: "Privacy",
	    toggle: "Logging in is required to see information about assigned resource and floormap"
	  },
	  layout_card: {
	    header: "Layout",
	    sub_header_descriprion: {
	      first_line: ["When using the Outlook add-in and Chrome extension, a wayfinding link is added to the event itself. ", "This shows invitees where they need to be and to easily find their way."],
	      second_line: "You can add a company logo OR company name, and define the colors for the banner, the company name and the titles."
	    },
	    logo: {
	      label: "Company logo",
	      sub_label: "(PNG, less than 4MB)"
	    },
	    image_info: ["max width 210px and ", "max height 50px"],
	    company_name: {
	      label: "Company name",
	      placeholder: "Max 20 characters"
	    },
	    name_color_label: "Color company name",
	    baner_color_label: "Color banner",
	    titels_color_label: "Color titles"
	  }
	}
      },
      todo: {
	navigation: {
	  list: 'Reservation to-do list',
	  requests: 'Requests',
	  reservation_table: 'Reservation table',
	  release_table: 'Release table'
	},
	main: {
	  all_button_tooltip: "Assign resources automatically to current to-do's",
	  dialog_asset: "Asset must be selected first",
	  details_resources_button: "View resource reservations",
	  legend: {
	    header: "View legend",
	    items: [
	      {name: "Available", type_class: "green"},
	      {name: "Available, but to be confirmed", type_class: "orange"},
	      {name: "Available, but rules constraint", type_class: "blue"},
	      {name: "Not available", type_class: "red"}
	    ]
	  }
	},
	list: {
	  update: "Last updated: ",
	  toggle: "Show only untreated request",
	  toggle_visitor: "Show only visitor reservations",
	  default_name_subject: "New reservation ",
	  user_prefix: "by ",
	  visitor_prefix: "for ",
	  tooltip: "Reservation within selected time range",
	  default_name_asset: "Reservation pending"
	},
	details: {
	  site_change: {
	    header: "Change site",
	    tooltip: "Remove assigned space first"
	  },
	  request: {
	    header: "Request",
	    treated: ["Request treated", "Request untreated"],
	    buttons: {
	      add: "Add note",
	      contact: "Contact user"
	    }
	  },
	  details: {
	    header: ["Show details", "Hide details"],
	    delete_button: "Cancel reservation",
	    default_name_subject: "New reservation ",
	    user_prefix: "By ",
	    visitor_prefix: "For ",
	    seats: {
	      counter: ["Requested: seats ","Requested: "],
	      type: ['internal meeting', 'external meeting'],
	      amenities: "Requested amenities: "
	    }
	  },
	  popups: {
	    delete: 'Delete this reservation?',
	    assigned: "Space is assigned to reservation and confirmed",
	    selected: "Asset must been selected",
	    available: "Asset is not available",
	    message_error: "error sending"
	  }
	},
	work_stack: "Click here to select the stack item",
	message_popup: {
	  header: "Add note",
	  sub_header: "Request",
	  treated: ["Request treated", "Request untreated"]
	},
	release_table: {
	  info: 'Changing time range removes all filters',
	  headers: {
	    number: { popup: '', name: "Number" },
	    user: { popup: 'Owners', name: "Assigned to" },
	    level: { popup: 'Level assigned user', name: "Level assigned user" },
	    neighbourhood: {name: "Neighbourhood", popup: "Neighbourhood"},
	    wing: { popup: 'Wings', name: "Wing" },
	    space: { popup: 'Resource', name: "Resource" },
	    amenities: { popup: '', name: "Resource’s amenities" },
	    from: { popup: '', name: "From" },
	    to: { popup: '', name: "To" },
	    subject: { popup: '', name: "Subject" },
	    email: { popup: '', name: "Email" }
	  },
	  tooltip: "send message to all",
	  dialogues: {
	    send_all_message: ["Send message to ", " shown releases for "],
	    remove_release: "Delete this release?",
	    remove_releases: ["Delete ", " shown releases for "],
	    error_message: "Error sending",
	  }
	},
	reservaton_table: {
	  info: 'Changing time range removes all filters',
	  change_site_buton: ' Change site for all',
	  headers: {
	    number: { popup: '', name: "Number" },
	    user: { popup: 'User', name: "User" },
	    visitor: { popup: 'Visitor', name: "Visitor" },
	    level: { popup: 'Level of user', name: "Level of user" },
	    group: { popup: 'User group in ', name: "User group in " },
	    email: { popup: '', name: "User email" },
	    neighbourhood: {name: "Neighbourhood", popup: "Neighbourhood"},
	    subject: { popup: '', name: "Subject" },
	    from: { popup: '', name: "From" },
	    to: { popup: '', name: "To" },
	    seats: { popup: 'Requested seats', name: "Requested seats" },
	    internal_external: { popup: 'Resource type', name: "Resource type" },
	    amenities: { popup: '', name: "Requested amenities" },
	    wing: { popup: 'Wings', name: "Wing" },
	    space: { popup: 'Resources', name: "Resource" },
	    request: { popup: 'Request', name: "Request" },
	    status: { popup: 'Statuses', name: "Status" },
	    acknowledged: { popup: 'Acknowledged', name: "Acknowledged" }
	  },
	  tooltip: {
	    lock: "lock all",
	    unlock: "unlock all",
	    acknowledged: "From reminder email: if the person clicked on the 'I agree' button and therefore acknowledges they have read the message",
	    confirm: "confirm all",
	    delete: "delete all",
	    send_mail: "send message to all"
	  },
	  dialogues: {
	    chang_site: 'Change site',
	    confirm: ['Confirm ', ' shown reservations from '],
	    send_all_message: ["Send message to ", " shown reservations for "],
	    remove_reservation: "Delete this reservations?",
	    remove_reservations: ["Delete ", " shown reservations for "],
	    error_message: "Error sending",
	    lock: ["Lock ", " shown reservations from "],
	    unlock: ["Are you sure you want to unlock ", " shown reservations from "]
	  }
	},
	requests_table: {
	  info: 'Changing time range removes all filters',
	  add_comment_buton: 'Add comment',
	  headers: {
	    number: { popup: '', name: "Number" },
	    user: { popup: 'Owners', name: "Owner" },
	    visitor: { popup: '', name: "Visitor" },
	    subject: { popup: '', name: "Subject" },
	    from: { popup: '', name: "From" },
	    to: { popup: '', name: "To" },
	    wing: { popup: 'Wings', name: "Wing" },
	    space: { popup: 'Resource', name: "Resource" },
	    request: { popup: 'Request', name: "Request" },
	    comment: { popup: '', name: "Comment" },
	    seats: { popup: '', name: "Request treated" },
	    email: { popup: '', name: "Owner email" }
	  },
	  tooltip: "send message to all",
	  dialogues: {
	    send_all_message: ["Send message to ", " shown reservations for "],
	    error_message: "Error sending"
	  }
	}
      },
      user_management: {
	navigation: {
	  global_admin: "Global admins",
	  admin: "Site admins",
	  privileges: "User privileges",
	  user: "User management",
	  users_table: "User table",
	  groups: "User groups",
	  sso: "SSO",
	  provisioning: "User provisioning"
	},
	global_admin: {
	  header: "Global admin management",
	  admins_card: {
	    header: "Define the global admins",
	    sub_header: "These users have access to all sites and features",
	    video_header: 'How to define the site & global administrators',
	    search: "Search",
	    global_admin_list_header: "Site admins that are global admin",
	    admin_list_header: "Site admins",
	    admin_list_header_tooltip: 'You need to be site admin first, before you can be global admin'
	  },
	},
	privileges: {
	  header: "User rules",
	  site_card: {
	    header: "Site",
	    sub_header: "Select a site to define it's user rules."
	  },
	},
	admin: {
	  header: "Site admin management",
	  site_card: {
	    header: "Site",
	    sub_header: 'Select a site for which you want to add or remove administrators.'
	  },
	  admins_card: {
	    header: "Add administrators for this site",
	    video_header: 'How to define the site & global administrators',
	    search: "Search",
	    admin_list_header: "Users that are admin for this site",
	    user_list_header: "Users",
	    popup: {
	      title: "This user has global admin rights and therefore access to all sites.",
	      descriptions: ["If you want to give this user only access to certain sites, remove them from the global admin list first."]
	    }
	  },
	},
	user: {
	  rfid_modal: {
	    header: "Assign RFID to user",
	    step1: {
	      header: ["Step 1", " - Enter device ID & click ‘Start’"],
	      placeholder: "Device ID",
	      button: "Start ",
	      info: ["No resource found ", "Check or re-enter ID"]
	    },
	    step2: ["Step 2", " - On connected device, tap ‘Book now’ or ‘Book later’"],
	    step3: {
	      header: ["Step 3", " - Scan card on the device, the RFID code will appear below"],
	      placeholder: "Card RFID"
	    },
	    step4: {
	      header: ["Step 4", " - Click ‘Assign RFID’, to assign it to the user"],
	      button: "Assign RFID"
	    }
	  },
	  header: "User management",
	  free_version_sub_header: ["Currently using the ", "FREE VERSION with a limit of ", " users.", " Contact ", " to upgrade."],
	  site_card: {
	    header: "Location",
	    sub_header: "Select a location to add or remove users for this site."
	  },
	  create_edit_card: {
	    list: {
	      header: "Existing users",
	      button: "Add new user",
	      placeholder: "search"
	    },
	    form: {
	      header: ["Edit user", "Create user"],
	      video_header: "How to create and edit a user",
	      sub_header: "Select a user in the list to edit it's details.",
	      name: {
		label: "Username",
		placeholder: "Name"
	      },
	      email: {
		label: "Email",
		placeholder: "Email"
	      },
	      level: {
		label: "User level ",
		placeholder: ""
	      },
	      group: {
		label: "User group",
		item: "Default"
	      },
	      site: {
		label: "Home site",
		item: "None"
	      },
	      resource: {
		label: "Resource",
		placeholder: ""
	      },
	      rfid: {
		label: "RFID",
		placeholder: "Enter RFID or click on icon on the right"
	      },
	      image: {
		label: "User image",
		sub_label: ["(square size, ", "less than 4MB)"]
	      },
	      button: {
		create: " Create user",
		reset_pin: "Reset PIN code",
		reset_password: "Reset user password",
		upload: "Upload image",
		delete: " Delete user",
		save: " Save changes"
	      }
	    },
	    import: {
	      header: "Batch upload users",
	      cases: [
		"1. Download template",
		"2. Add users for this location to the template",
		"3. Upload the template file again to Tribeloo"
	      ],
	      button: {
		upload: "Upload file",
		download: "Download template"
	      }
	    },
	    errors: {
	      invalid_email: "Required field <email> is invalid.",
	      missing_email: "Required field <email> is missing from request.",
	      missing_name: "Required field <name> is missing from request.",
	      missing_level: "Required field <level> is missing from request.",
	    },
	    popups: {
	      save: 'Save changes?',
	      create: 'Create user?',
	      created: 'User created.',
	      reset_pin: 'The reset was succesful! The user will receive an email with a new PIN code.',
	      updated: 'User details have been updated.',
	      delete: ' Delete this user?',
	      removed: 'User removed.',
	      reset_password: 'The reset was succesful! The user will receive an email with a new password.',
	      send_pin: 'Send login PIN code for devices ?'
	    }
	  },
	  pin_card: {
	    header: "PIN code ",
	    video_header: "When and how to use a PIN code",
	    toggle: "Send PIN code by email to login on the meeting room and desk devices",
	    info: "All new users and existing users that don’t have PIN code yet, will receive one."
	  },
	  global_settings_card: {
	    header: "Global settings",
	    info: "These settings are applicable for all sites"
	  },
	  image_card: {
	    header: "Synchronise user images ",
	    video_header: "How to synchronise user images of Microsoft 365 with Tribeloo",
	    toggle: "Sync user images with Microsoft Office 365",
	    info: "User image is synchronised once a user logs into the Tribeloo Outlook add-in"
	  },
	  subject_card: {
	    header: "Hide reservation subject ",
	    video_header: "",
	    toggle: "Hide reservation subject for colleagues",
	    info: 'Reservation subject shown in "who`s around" will be hidden'
	  }
	},
	users_table: {
	  batch_edit: {
	    header: "Edit user details",
	    sub_header: "Update",
	    items: {
	      privileges: "User group",
	      level: "User level",
	      site: "Home site",
	      group: "User group",
	      rfid: "Clear RFID for selected users"
	    }
	  },
	  table: {
	    toggle: 'Also show users from other sites',
	    headers: {
	      number: { popup: '', name: "Number" },
	      site: { popup: 'Home Site', name: "Home site" },
	      home_site_privilege: { popup: 'Home site group', name: "Home site group" },
	      user: { popup: '', name: "Name of user" },
	      user_privilege: { popup: 'User group in ', name: "User group in " },
	      assigned_resource: { popup: 'Assigned resource in ', name: "Assigned resource in " },
	      level: { popup: 'Level of user', name: "Level of user" },
	      group: { popup: 'Group', name: "User group" },
	      space: { popup: '', name: "Resource" },
	      Owned_site: { popup: 'Owned_site', name: "Site of resource" },
	      email: { popup: '', name: "User email" },
	      rfid: { popup: 'RFID', name: "RFID" },
	      override : {popup: 'Group assignment', name: "Group assignment"}
	    },
	    tooltip: {
	      delete: "delete all selected users",
	      send_mail: "send message to selected users"
	    },
	    dialogues: {
	      error_message: "Error sending",
	      email: 'Compose email for the selected users?',
	      selected: "At least one user must be selected.",
	      delete_all: ['Delete the ', ' selected users?'],
	      delete: 'Delete this user?',
	      rfid: "RFID cleared for selected users"
	    }
	  }
	},
	groups: {
	  header: "Users groups",
	  toggle_card: {
	    header: "Enable user groups ",
	    video_header: "How to set up user groups",
	    toggle: "User groups are enabled",
	    description: ["When ", "enabled", ", you can create user groups and define rules for visible sites or office days for each group.", "Assign a user to a group in user management or user table."]
	  },
	  creat_edit_card: {
	    list: {
	      header: "Existing users groups",
	      button: "Add new user group",
	      placeholder: "search",
	      popups: {
		save: "Save changes?",
		create: "New user group is added.",
		update: "Changes saved.",
		delete: {
		  text: "Delete this user group?",
		  descriptions: ['Users from this group will be assigned to the default user group of their home site.']
		}
	      }
	    },
	    form: {
	      header: ["Create user group", "Edit user group"],
	      select_button: "Select all",
	      unselect_button: "Unselect all",
	      create: " Create group",
	      update: "Save changes",
	      delete: " Delete group",
	      name: {
		label: "Name ",
		placeholder: "Add name of user group"
	      },
	      rules: {
		toggle: ["‘Visible sites’ rule enabled", "‘Visible sites’ rule disabled"],
		tooltip: "When visible sites rule is enabled, a user has access to the active sites of his group, and is able to book a resource for these sites. When visible sites rule is disabled, this user group has access to all active sites.",
		placeholder: "Select visible sites",
	      },
	      days: {
		toggle: ["‘Office days’ rule enabled", "‘Office days’ rule disabled"],
		tooltip: "When office days rule is enabled, a user can make reservation only on the selected office days. When office days rule is disabled, this user group can make reservations on all days.",
		placeholder: "Select office days",
		week_days: ['lunes', 'martes', 'miérocles', 'jueves', 'viernes', 'sábado', 'domingo']
	      }
	    },
	    sites_card: {
	      header: "Default user group for each site",
	      description_lines: [
		{start: "Users can be assigned to a specific group. In case a user doesn’t have a group assigned,", end: "the user will fall in the default group of his home site as defined below."},
		{start: "In case the user isn’t assigned to a specific group and no default group is defined for his", end: "home site, the user will only have access to his home site to book resources."}
	      ],
	      label: "No home site ",
	      tooltipe: "This is the default group for users without a home site",
	      placeholder: "group"
	    }
	  }
	},
	sso: {
	  header: "Single Sign-On",
	  description_card: {
	    header: "What is it?",
	    description: "Single Sign-On gives your users the ability to sign in to different applications using the same unique set of username and password. Users sign in once via the so-called Identity Provider (external to Tribeloo) and can then, from there access different apps (including Tribeloo) without logging in again. For SSO, Tribeloo supports the SAML 2.0 standard."
	  },
	  email_card: {
	    header: "Enable welcome email",
	    toggle: "Enable sending welcome email if SSO is enabled"
	  },
	  settings_card: {
	    header: "Settings",
	    items: {
	      id: {
		name: "Company ID",
		tooltip: {
		  header: "",
		  descriptions: []
		}
	      },
	      issuer_url: {
		name: "Issuer URL",
		tooltip: {
		  header: "Also referenced to as",
		  descriptions: ["Okta: Identity Provider Issuer", "OneLogin: Issuer URL", "Azure: Azure AD Identifier", "Google: Entity ID"]
		}
	      },
	      login_url: {
		name: "SSO login URL",
		tooltip: {
		  header: "Also referenced to as",
		  descriptions: ["Okta: Identity Provider SSO URL", "OneLogin: SAML Endpoint", "Azure: Login URL", "Google: SSO URL"]
		}
	      },
	      certificate: {
		name: "Certificate",
		tooltip: {
		  header: "Also referenced to as",
		  descriptions: ["Okta: X.509 Certificate", "OneLogin: X.509 Certificate", "Azure: Certificate (Base64 or Raw)", "Google: Certificate 1"]
		}
	      },
	    },
	    button: ["Disable SSO", "Enable SSO"]
	  },
	  popups: {
	    saved: 'Configuration saved.',
	    not_saved: 'Configuration not saved.',
	    copied: 'Company ID copied.',
	    change_sso: {
	      text: ['Are you sure you want to disable Single Sign-On?', 'Are you sure you want to enable Single Sign-On?'],
	      descriptions: ['All users will need to log in with a password, that they can request through ‘Forgot password?’ on the login page.', 'Users won’t be able to log in with their passwords and will need to log in with their SSO credentials.']
	    }
	  }
	},
	provisioning: {
	  header: "User provisioning",
	  description_card: {
	    header: "What is it?",
	    description: "User Provisioning refers to the automatic synchronization of users: people defined in your Active Directory (AD) will be automatically synchronized with the Users list in Tribeloo. E.g. new people in the AD will be added to the Users list in Tribeloo."
	  },
	  settings_card: {
	    header: "Settings",
	    items: [
	      {name: "SCIM Base URL", key: "base_url", is_input: true},
	      {name: "SCIM JSON Template", key: "json_template", is_input: false},
	      {name: "Custom headers", key: "custom_headers", is_input: true},
	      {name: "SCIM Bearer token", key: "bearer_token", is_input: false}
	    ],
	    button: ["Disable User provisioning", "Enable User provisioning"],
	    popups: {
	      copy: " copied",
	      change_SCIM: {
		text: ['Are you sure you want to disable User provisioning?', 'Are you sure you want to enable User provisioning?'],
		description: ['All the current users will be kept, but won’t be updated by your external user provisioning system anymore.', 'All users will be managed externally.']
	      }
	    }
	  }
	}
      },
      insights: {
	navigation: {
	  heatmaps: "Heatmaps",
	  utilization: "Utilization charts",
	  history: "Reservation history",
          neighbourhoods: "Neighbourhoods",
	  download: "Data download",
	  statistics: "Statistics",
	  tracker: "Time tracking",
	  calc: "Calc resource"
	},
	calc: {
	  type: "Calc helpe",
	  subHeader: "This page help you with a data about your price and amount of resources from 1 month to 5 years. Also it help you: if you want to change a count of recources, or move to new place, add or remove new site, wing and etc.",
	  chartHeader: "Terms & summ",
	  chartDescription: "Use top form to know how much you are spending for your resources"
	},
	heatmaps: {
	  type: "Heatmaps",
	  subHeader: "Which days and hours are most busy?",
	  allText: "Average utilization rate of selected type",
	  daysText: "Daily utilization rate of selected type",
	  options: {
	    average: "Show average utilization rate",
	    daily: "Show daily utilization rate"
	  },
	  tooltipe: 'The average utilization rate is a percentage of the time that the space has been used, within the working hours of the selected time period. The daily utilization rate is the percentage of days that the desk has been used at least once from all days in the selected time period. For example, daily utilization of 80% and average utilization of 40% means that: 8 out of 10 desks are being used at least once during a working day and that these 8 desks are on average used during half of the working hours. '
	},
	utilization_charts: {
	  type: "Utilization charts",
	  subHeader: "Which days and hours are most busy?",
	  allText: "Average utilization rate of selected type",
	  daysText: "Daily utilization rate of selected type",
	  table_header: "Which days are most busy? Select a day to see the utilization by hour below for that day.",
	  chart_header: "Which hours are most busy"
	},
	reservation_history: {
	  info: 'Changing time range removes all filters',
	  overlap: 'Find overlapping reservations with ',
	  couter: " more...",
	  headers: {
	    number: { popup: '', name: "Number" },
	    user: { popup: 'Owners', name: "User" },
	    visitor: { popup: 'Visitor', name: "Visitor" },
	    email: { popup: '', name: "User email" },
	    from: { popup: '', name: "From" },
	    to: { popup: '', name: "To" },
	    wing: { popup: 'Wings', name: "Wing" },
	    space: { popup: 'Resources', name: "Resource" },
	    no_shows: { popup: 'No-shows', name: "No-shows" },
	    subject: { popup: '', name: "Subject" },
	    seats: { popup: 'Requested seats', name: "Requested seats" },
	    internal_external: { popup: 'internal/external', name: "internal/ external" },
	    status: { popup: 'Statuses', name: "Status" },
	    messages: { popup: 'Messages', name: "Messages" },
	    acknowledged: { popup: 'Acknowledged', name: "Acknowledged" }
	  },
	  tooltip: {
	    acknowledged: "From reminder email: if the person clicked on the 'I agree' button and therefore acknowledges they have read the message",
	    send_mail: "send message to all"
	  },
	  dialogues: {
	    error_message: "Error sending"
	  }
	},
	time_tracking: {
	  check: "events",
	  info: 'Changing time range removes all filters',
	  info_date: 'Find overlapping reservations with ',
	  headers: {
	    user: { popup: 'User', name: "User" },
	    email: { popup: 'User email', name: "Email" },
	    from: { popup: '', name: "From" },
	    to: { popup: '', name: "To" },
	    zone: { popup: '', name: "Time zone" },
	    period: { popup: '', name: "Time period" },
	  },
	  dialogues: {
	    error_message: "Error sending"
	  }
	},
	data_download: {
	  header: "Data download",
	  popup: {
	    big_titel: 'Update data retention?',
	    big_descriptions: ['Older reservation data will be deleted and no longer accessible'
			      ]},
	  retention_card: {
	    header: "Data retention",
	    toggle: ["Reservations & releases data is automatically deleted after", "days."],
	    info: "There is a minimum of 7 days and a maximum of 400 days."
	  },
	  automade: {
	    header: "Daily automated report via email",
	    sub_header: "Receive data of the reservations & releases of the previous day",
	    check: "Send daily email to",
	    placeholder: "Email address",
	    error: "Please enter a valid email address"
	  },
	  download: {
	    header: "Download data for a specific time range",
	    info: "Data of reservations & releases",
	    button: {
	      all: " Download all",
	      one: " Download data range"
	    }
	  }
	},
	statistics: {
	  header: "Statistics",
	  sub_header: "The table shows you a current view of all the sites and their amount of resources and users.",
	  card: {
	    header: "Resources and users",
	    button: "Download",
	    table_headers: {
	      type: "Resource type",
	      resources: "Resources",
	      users: "Users"
	    }
	  }
	},
	reusable_components: {
	  main_header: {
	    header: "Insights",
	    day: " Move timeframe per day ",
	    week: " Move timeframe per week "
	  },
	  scale_utilization_rate: "Scale utilization rate",
	  card_table: {
	    table_headers: {
	      special: "utilization rate",
	      average: "Average",
	      daily: "Daily"
	    },
	    description_hightlight: [
	      {start:"The ", hightlight: "average", end: " utilization rate is a percentage of the time that the space has been used, within the working hours of the selected time period."},
	      {start:"The ", hightlight: "daily", end: " utilization rate is the percentage of days that the desk has been used at least once from all days in the selected time period."}
	    ],
	    description_example: ["  For example, daily utilization of 80% and average utilization of 40% means that: ", "8 out of 10 desks are being used at least once during a working day and that these 8 desks are on average used during half of the working hours."]
	  },
	  maps_cards: {
	    button: {
	      select: "Select",
	      show_all: "Show all"
	    },
	    internal_external: [', Internal only', ', External allowed'],
	    owner: "Owner: ",
	    usage: "Usage",
	    average: "average: ",
	    daily: "daily: ",
	    days: "days active: ",
	  }
	}
      },
      space_issues: {
	navigation: ['Issue management','Cleaning', 'Issues table'],
	list: {
	  main_header: 'Select a site',
	  main_sub_header: 'Find resource',
	  placeholder: "Please search or select a site",
	  placeholder_asset: "Please search or select a resource",
	  search: 'View all site issues',
	  toggle: ['Click to show closed issues','Click to show open issues'],
	  couter: [' open resource issues', ' closed resource issues'],
	  img_link: 'See photo',
	  popup_text: 'E-mail sent to your account with information about the issue. This can be forwarded to somebody that can solve it.',
	},
	table_cleaning: {
	  main_header_warning: 'Changing time range removes all filters',
	  table_headers: {
	    id:'ID',
	    data_time: 'Date & time',
	    wing: 'Wing',
	    resource: 'Resource',
	    cleaned_at: 'Cleaned at',
	    cleaned_by: 'Cleaned by'
	  }
	}
      }
    },
    user: {
      external_events_list: {
	headers: [ "Eventi Google", "Eventi Outlook" ],
	select: {
	  header: "Organizzato da",
	  placeholder: "Seleziona collega/INVITA PERSONE"
	},
	info: [
	  "Nessuna prenotazione disponibile dal tuo calendario",
	  "Mostra solo eventi con prenotazioni Tribeloo",
	  "Seleziona evento"
	]
      },
      find_colleague: {
	email_select: {
	  more: "altro..."
	},
	user_select: {
	  header: "Trova collega",
	  placeholder: "Seleziona collega",
	  info: [ "Richiedi l'accesso ai tuoi colleghi in", "La mia Tribù", "per visualizzare le loro prenotazioni" ]
	},
	list: {
	  count: " (non privata)",
	  info: [ "Seleziona un collega per visualizzare le sue prenotazioni", "Clicca sulla prenotazione per visualizzarla sulla mappa." ]
	},
	details: {
	  return_button: "Torna all'elenco prenotazioni",
	  info: "Seleziona una PRENOTAZIONE (attiva) disponibile sulla mappa per creare una prenotazione",
	  modals: {
	    delete_reservation: "Prenotazione eliminata",
	    create_reservation: "Crea una prenotazione"
	  }
	}
      },
      find_room_report: {
	headers: {
	  main: "Segnala un problema per una risorsa",
	  site: "Seleziona un sito",
	  resource: "Trova risorse"
	},
	placeholders: {
	  site: "Cerca o seleziona il luogo",
	  resource: "Cerca o seleziona la risorsa",
	  tooltip: "Segnalando un problema, verrà inviato all'amministratore del sito per essere risolto. Una volta risolto, verrà rimosso da questo elenco.",
	  description: [ "Seleziona una risorsa per segnalare un problema", "Segnala un problema con la risorsa" ]
	},
	loading: "Caricamento in corso",
	image_description: "Immagine",
	button: {
	  photo: "Allega foto",
	  send: "Invia problema"
	},
	image_info: "Immagine (< 4MB)",
	couter: "problemi di risorse aperti"
      },
      releases_list: {
	add_button: "Aggiungi fuori sede",
	user_select: "Fuori sede per",
	colleagues_info: "Non hai colleghi con uscite visibili",
	counter: "Nessuna uscita",
	right_panel_info: [
	  "Seleziona un collega dal menu a tendina per vedere le sue uscite.",
	  "\nNon hai colleghi con uscite visibili."
	]
      },
      release: {
	pageName: "rilascio",
	header: "Dettagli fuori sede",
	placeholder: "Oggetto",
	buttons: {
	  create: [ "Rilascia il tuo", "Conferma" ],
	  edit: [ "Annullare questo rilascio?", "Annulla" ]
	},
	description: [ "Esistono", "nessuna", "prenotazione(i) attiva(e) per questo", "durante questo intervallo di tempo." ],
	modals: {
	  user: "Cambiare utente? La versione attuale verrà eliminata.",
	  not_available: "Rilascio non disponibile",
	  delete: "Eliminare questa versione?"
	}
      },
      reservations_list: {
	add_button: "Aggiungi nuova prenotazione",
	user_select: "Prenotazioni per",
	tabs: [
	  {name:"Personale", state: false},
	  {name:"Ospite", state: true}
	],
	colleagues_info: "Non hai colleghi con prenotazioni visibili",
	counter: "Nessuna prenotazione",
	right_panel_info: [
	  "Seleziona un collega dal menu a tendina per vedere le sue prenotazioni.",
	  "Modifica una prenotazione o creane una nuova per vedere le risorse disponibili"
	]
      },
      reservation: {
	pageName: "prenotazioni",
	header_requests: [ "Non hai ancora prenotato.", "Completa i dettagli e controlla la disponibilità." ],
	details: "dettagli",
	end: "Termina prenotazione",
	amenities_item: "altra richiesta",
	snack_bars: {
	  create: "Prenotazione creata",
	  update: "Prenotazione aggiornata"
	},
	visitor: {
	  text: "Prenotazione per ospite"
	},
	placeholders: {
	  visitor: "Indirizzo mail",
	  amenities: "Seleziona servizi",
	  no_amenities: "Nessun elemento trovato",
	  subject: "Oggetto",
	  neighbourhood: "Seleziona quartiere"
	},
	public: {
	  text: "Rendi privato per tutti",
	  tooltip: "La tua prenotazione è sempre visibile ai membri della tua tribù. L'attivazione di questa opzione la renderà invisibile a tutti, inclusa la tua tribù."
	},
	right_panel_info: {
	  no_checked_availability: [ "Completa i dettagli e", "controlla la disponibilità", "per prenotare una risorsa" ],
	  checked_availability: [ "I dettagli della richiesta sono cambiati,", "controlla di nuovo la disponibilità" ]
	},
	modals: {
	  amenity: {
	    text: "La tua prenotazione attuale non si adatta a tutti i servizi!",
	    descriptions: ["Ma non preoccuparti, puoi continuare con la prenotazione attuale."]
	  },
	  error_404: "Prenotazione non disponibile",
	  requested_capacity: {
	    text: "Lo spazio assegnato non ha abbastanza posti!",
	    descriptions: [ "Continua per mantenere il nuovo numero di posti e cerca un nuovo spazio.", "Oppure annulla la modifica del posto e mantieni il tuo spazio attuale." ]
	  },
	  internal: {
	    text: "Il tuo spazio assegnato è solo per riunioni interne!",
	    descriptions: [ "Continua per mantenere la modifica e cerca un nuovo spazio.", "Oppure annulla la modifica e mantieni il tuo spazio attuale." ]
	  },
	  time: {
	    text: "La tua prenotazione non è disponibile per questo orario!",
	    descriptions: [ "Continua per mantenere il nuovo orario e la tua prenotazione verrà aggiornata.", "Oppure annulla la modifica dell'orario e mantieni la tua prenotazione attuale." ]
	  },
	  space: {
	    text: "Il tuo spazio assegnato è solo per riunioni interne!",
	    descriptions: [ "Continua per mantenere la modifica e cerca un nuovo spazio.", "Oppure annulla la modifica e mantieni il tuo spazio attuale." ]
	  },
	  invalid_email: "Devi inserire un'e-mail di ospite valida o disattivare il selettore ospite per creare una prenotazione.",
	  delete: {
	    simple: { text: "Eliminare questa prenotazione?" },
	    ongoing: { text: "Terminare questa prenotazione?" },
	    visitor_change: {
	      text:{
		toggle: 'Cambiare tra prenotazione personale e ospite eliminerà la prenotazione attuale!',
		email: 'Cambiare l\'indirizzo e-mail dell\'ospite eliminerà la tua prenotazione attuale!',
	      },
	      descriptions: [
		"Continua per mantenere i cambiamenti e la tua prenotazione verrà aggiornata.",
		"Oppure annulla la modifica e mantieni la tua prenotazione attuale."
	      ]
	    },
	    user_change: {
	      text: "Cambiare utente eliminerà la tua prenotazione attuale!",
	      descriptions: [ "Continua per mantenere il nuovo utente e la tua prenotazione verrà aggiornata.", "Oppure annulla la modifica e mantieni la tua prenotazione attuale." ]
	    },
	    site_change: {
	      text: "Se cambi sito, la tua prenotazione attuale verrà eliminata.",
	      descriptions: [ "Continua per mantenere il nuovo sito e la tua prenotazione verrà aggiornata.", "Oppure annulla la modifica e mantieni la tua prenotazione attuale." ]
	    }
	  }
	}
      },
      home: {
	nwesfeed_list: "Nessuna notizia oggi!",
	pageName: "Home",
	emergency: {
	  header: "MESSAGGIO DI EMERGENZA",
	  by: "di"
	},
	reservation: {
	  headers: {
	    upcoming: "La tua prossima prenotazione",
	    current: "La tua prenotazione attuale",
	    no_upcoming: "Nessuna prossima prenotazione"
	  },
	  descriptions: [ "Sono qui per aiutarti!", "Fai la tua scelta con i pulsanti sottostanti." ],
	  loading: "Caricamento in corso..."
	},
	newsfeed_header: "Notizie"
      },
      settings: {
	pageName: 'impostazioni',
	h1: 'Impostazioni utente',
	password: {
	  errors: ["Almeno 1 numero, 1 simbolo e 8 caratteri di lunghezza", 'Le password non corrispondono'],
	  rules: 'La password deve contenere almeno: 8 caratteri, 1 maiuscola, 1 minuscola, 1 numero',
	  rules_v2: 'Deve contenere almeno: 8 caratteri, 1 maiuscola, 1 minuscola, 1 numero',
	  placeholders: ['Inserisci nuova password', 'Reinserisci nuova password'],
	  info_ok:"Password cambiata con successo",
	  info_not_ok: "La password non è stata cambiata"
	},
	h3_sections: {
	  password: 'Cambia password',
	  image: 'Aggiungi immagine utente',
	  site: 'Sito predefinito per le prenotazioni',
	  wing: 'Ala predefinita per le prenotazioni',
	  time: 'Formato ora',
	  language: 'Lingua',
	  preferences: 'Preferenze',
	  preferences_v2: 'Preferenze utente',
	  delegate: 'Delegato',
	  calendar: 'Inviti a calendario',
	  wants_asset_details_popup: 'Dettagli mappe'
	},
	subsections: {
	  app: "Versione app",
	  sites: "Siti visibili",
	  language: "Lingua",
	  time: "Formato ora",
	  calendar: "Inviti a calendario"
	},
	user_image_info: ['Contatta il tuo', 'office manager per cambiare l\'immagine utente'],
	user_image: ['Immagine utente', '(dimensioni quadrate, meno di 4MB)', 'Carica un\'immagine quadrata di dimensioni inferiori a 4MB'],
	toggle: 'Usa formato ora 24 ore',
	app_version: "Usa la nuova versione (riavvio necessario)",
	calendar_toggle: 'Invia inviti a calendario per le prenotazioni effettuate nell\'applicazione web',
	wants_asset_details_popup_toggle: 'Mostra pop-up dettagli quando si seleziona una risorsa sulla mappa',
	no_delegates: 'Nessun delegato',
	delegates_action_list: {
	  search: 'Cerca',
	  edit: 'Colleghi che possono creare o modificare le mie prenotazioni',
	  add: 'Aggiungi colleghi'
	},
	delegates_modal: "Selezionando questa casella, la tabella sottostante verrà ignorata e chiunque potrà vedere le tue riunioni pubbliche."
      },
      who_is_arround: {
	header: "Chi è nei dintorni",
	tooltip: "Controlla chi è in ufficio in un dato momento. Non hai ancora una Tribù? Creane una in 'La mia Tribù'.",
	date_time: {
	  main: "Data e ora",
	  helper: "ORA"
	},
	info: "Seleziona una risorsa disponibile sulla mappa per creare una prenotazione per te",
	users_list: {
	  header: {
	    hide: "Nascondi",
	    show: "Mostra",
	    postfix: "elenco dei colleghi"
	  },
	  placeholder: "Nome utente"
	},
	right_panel_info: "Scegli una posizione per visualizzare l'occupazione",
	modal: "Creare una prenotazione?"
      },
      my_tribe: {
	header: "La mia Tribù",
	tabs: [ "Follower", "Seguiti" ],
	info: [ "Colleghi che possono vedere le tue prenotazioni non private", "Richieste per seguirti", "Colleghi le cui prenotazioni non private puoi vedere" ],
	serach_header: "Risultati della ricerca",
	no_results: "Nessun risultato",
	placeholders: [ "Cerca", "Cerca colleghi da seguire" ],
	modals: {
	  confirm: {
	    text: "Vuoi seguire anche questo collega?",
	    cancel: "Non seguire",
	    confirm: "Segui"
	  },
	  delete: {
	    text: "Vuoi eliminare la richiesta di questo collega?",
	    cancel: "Annulla",
	    confirm: "Elimina richiesta"
	  },
	  remove: {
	    text: "Vuoi eliminare questo collega?",
	    cancel: "Annulla",
	    confirm: "Elimina"
	  },
	  cancel: {
	    text: "Vuoi annullare la tua richiesta?",
	    cancel: "No",
	    confirm: "Annulla"
	  },
	  unfollow: {
	    text: "Vuoi smettere di seguire questo collega?",
	    description: ["Se cambi idea, dovrai richiedere di seguirlo di nuovo."],
	    cancel: "Annulla",
	    confirm: "Smetti di seguire"
	  }
	}
      },
      squads: {
	header: 'I miei team',
      },
      qr: {
	header: "Check-in QR o walk-in",
	checkout: "Vuoi fare il check-out?",
	checkedout: "Check-out effettuato",
	photo_description: "Scansiona il codice QR per fare il check-in per la tua prenotazione attuale o per crearne una senza prenotazione",
	start_scan_description: "Punta il codice QR e tocca qui",
	errors: {
	  camera: "La fotocamera non è supportata su Chrome, usa Safari",
	  app: "Prova a usare un'app speciale per la scansione QR!",
	  device: "Usa un dispositivo mobile o un tablet con una fotocamera posteriore!"
	},
	modals: {
	  info: "L'accesso alla fotocamera è necessario per scansionare il codice QR.",
	  check_in: {
	    header: "Check-in per:",
	    from_to: [ "Da:", "A" ],
	    subject_default: "Prenotazione"
	  }
	}
      },
      help_center: {
	nav: {
	  demo: {
	    header: "Demo rapida",
	    card: {
	      headers: [],
	      descriptions: ["Guarda questa rapida demo per avere una buona panoramica di tutte le funzionalità di Tribeloo."],
	      links: []
	    }
	  },
	  get_started: {
	    header: "Guida per iniziare",
	    sub_headers: [ "Video di configurazione", "Single sign-on", "Provisioning utenti" ],
	    card: {
	      headers:[],
	      descriptions: [ "Scopri come iniziare con Tribeloo ed eseguire la configurazione iniziale della piattaforma.", "Consulta le linee guida su come installare la funzione single sign-on", "Consulta le linee guida su come installare la funzione di provisioning utenti" ],
	      links: ["qui."]
	    }
	  },
	  site_manager: {
	    header: "Gestore del sito",
	    sub_headers: [ "Video esecutivo", "Configura dispositivi" ],
	    card: {
	      headers: ["Configura dispositivi"],
	      descriptions: [ "Scopri come utilizzare Tribeloo come responsabile d'ufficio.", "Scopri come configurare i dispositivi per scrivanie e sale riunioni." ],
	      links:[]
	    }
	  },
	  user: {
	    header: "Utente",
	    sub_headers: [ "Video esecutivo", "Utilizzare l'add-in di Outlook", "Installare l'add-in di Outlook", "Utilizzare l'estensione di Chrome", "Installare l'estensione di Chrome", "Installare l'app su iPhone", "Installare l'app su Android" ],
	    card: {
	      mobile: "Scopri come utilizzare l'app mobile Tribeloo e la soluzione di prenotazione web.",
	      outlook: {
		headers: [ "Come usare l'add-in di Outlook", "Come installare l'add-in di Outlook" ],
		descriptions: [ "Scopri come usare l'add-in Tribeloo per Outlook.", "Scopri come installare l'add-in Tribeloo per Outlook.", "Vai al", "Microsoft Store", "per scaricarlo." ]
	      },
	      google: {
		headers: [ "Come usare l'estensione di Chrome", "Come installare l'estensione di Chrome" ],
		descriptions: [ "Scopri come usare l'estensione Tribeloo per Chrome e l'integrazione con il tuo Google Calendar", "Scopri come installare l'estensione Tribeloo per Chrome, integrata con il tuo Google Calendar.", "Vai al", "Chrome Web Store", "per scaricarla." ]
	      },
	      pwa: {
		headers: [],
		descriptions: [ "Guarda il video qui sotto o", "scarica il PDF", "su come installare l'app Tribeloo sul tuo iPhone", "su come installare l'app Tribeloo sul tuo Android" ]
	      }
	    }
	  },
	  feedback: {
	    sub_headers: [],
	    header: "Contattaci",
	    card: {
	      headers: ["Non trovi quello che cerchi? O vuoi darci un feedback?"],
	      descriptions: ["Lasciaci aiutarti! Condividi tutti i dettagli possibili in modo che possiamo aiutarti più velocemente."],
	      links:[]
	    }
	  }
	},
	main: {
	  header: "Centro assistenza",
	  subheaders: [ "Benvenuto!", "Trova informazioni utili su come iniziare a usare Tribeloo.", "Puoi sempre tornare qui cliccando su 'Centro assistenza' nella home page o nelle impostazioni." ],
	  orange_card: [ "Clicca sulle", "icone nel software per saperne di più su un argomento specifico." ]
	}
      }
    }
  },
  shared_components: {
    wings_select: "Tutte le ali",
    activity_select: {},
    assets_map: {
      types_external_internal: [ "Solo interno", "Esterno consentito" ],
      owner: "Assegnato a:",
      time_slots: "Disponibile:",
      no_time_slots: "Nessuno slot temporale disponibile",
      not_reservable: "Non puoi prenotare questa risorsa"
    },
    attendees_modal: {
      header_text: {
	share: "Condividi con i tuoi colleghi",
	attendees: "Stanno partecipando a questo evento"
      },
      info: [ "Seleziona i colleghi dal menu a tendina per inviare loro un'email.", "Per prima cosa, chiedi ai tuoi colleghi di aggiungerti alla loro tribù." ],
      placeholdrs: {
	colleagues: "Seleziona collega",
	message: "Scrivi qui il tuo testo"
      },
      button_attendees: [ "Non vai?", "Andrai?" ],
      more: "altro...",
      send: "Invia",
      send_all: "Invia email a tutti",
      counter: "partecipanti"
    },
    total_counter_download_table_csv: {
      batch_buton: 'Modifica in blocco',
      button: "Scarica",
      text: "in totale",
      selected: "Selezionato",
      info:"Nessun dato per i parametri selezionati"
    },
    confirm_dialog: {},
    date_time_range_modal: {
      headers: {
	main: "Imposta data e ora",
	from: "Da",
	to: "A"
      },
      tooltip: "Clicca per mostrare il calendario",
      info: "L'ora 'A' deve essere successiva all'ora 'Da'"
    },
    date_time_range_view: {
      headers: {
	from: "Da",
	to: "A",
	start: "Inizia",
	end: "Termina"
      }
    },
    day_time_mini: {
      header: ["Imposta", "data e ora"],
      tooltip: {
	calendar: "Clicca per mostrare il calendario",
	time: "Clicca per mostrare l'ora"
      }
    },
    download_xlsx: {},
    expanded_filter_assets_list: {
      modal: {
	header: "Informazioni sulle risorse",
	report_button: "Segnala un problema"
      },
      header: "elenco disponibilità",
      description: "Mostra solo con tutti i servizi",
      nospace: "Nessuno spazio disponibile",
      types_external_internal: [ "interno", "esterno" ],
      placeholder: "Cerca",
      tooltip: "Lo spazio non contiene tutti i servizi richiesti"
    },
    filter_dialog: {},
    icon_video: "Maggiori informazioni",
    info_dialog: {},
    kiosk_logout_info_modal: {
      message: "Stai ancora lavorando qui?",
      info: ["La tua sessione terminerà tra", "secondi."]
    },
    newsfeed_create_edit_item: {
      popup: "Eliminare le modifiche non salvate?",
      markdown: "È supportata la formattazione con Markdown",
      link: "Controlla le linee guida",
      image_info: "Immagine (< 4MB, dimensioni 335 x 75 px)",
      radio: ["Tipo:", "Notizia", "Evento"],
      placeholder: {
	event: "Nuovo evento",
	location: "Posizione",
      }
    },
    newsfeed_item: {
      default_subject: "",
      actions: [ "altro", "chiudi" ]
    },
    loading_table_spinner: 'caricamento dati',
    reservation_header_info: {
      state: ['Prenotazione in sospeso', 'Assegnato'],
      info: "Verifica disponibilità per assegnarne uno",
      internal_external: [ ', interno', ', esterno']
    },
    reservation_tipe_modal: "Nessuna opzione da aggiungere, modifica la prenotazione esistente",
    site_dialog: {},
    site_select: {
      placeholder: "Seleziona sito",
      tooltip: "Clicca qui per selezionare il sito",
      options: [ "Tutti i siti", "Nessun sito di partenza" ]
    },
    site_wings_reservation_view_external_data_set: "Clicca per andare in quest'ala",
    table_datetime_range_helper: {},
    time_range_helper: {}
  },
  user_shared_components: {
    capcity_internal_block: {
      placeholder: "posti" /* tooltip: 'Riunione esterna: con visitatori esterni &#13;Riunione interna: solo con dipendenti interni',*/,
      tooltip: "Riunione esterna: con visitatori esterni. Riunione interna: solo con dipendenti interni",
      select: [ "Spazio singolo", "Riunione interna", "Riunione esterna", "Stanza" ]
    },
    list_item: {
      internal_external: [ ", interno", ", esterno" ],
      info_reservation: [ "Prenotazione in sospeso, te ne verrà assegnata una a breve.", "Oppure controlla la disponibilità per sceglierne uno tu stesso." ],
      subject: [ "Nuova assenza", "Nuova prenotazione" ],
      status: "rilasciato",
      header: "Il tuo"
    },
    message_details: {
      toggle: "Aggiungi richiesta",
      info: [ "Richiesta non trattata", "Richiesta trattata" ],
      placeholder: "Lascia una richiesta al responsabile dell'ufficio se hai richieste aggiuntive"
    },
    weeks_repeater: {
      title: "Ripeti fino a",
      weekdaysShort: ['dom', 'lun', 'mar', 'mer', 'gio', 'ven', 'sab']
    },
    repeater_modal: {
      header: "Personalizza la ricorrenza",
      repeat_until: "Ripeti fino a",
      repeat_on: "Ripeti il"
    }
  },
  reusable_data: {
    time_tracking_popup: {
      big_titel: "Hai lavorato per",
      descriptions: ["Vuoi terminare la tua giornata lavorativa?"]
    },
    tables: {
      from: "Da",
      to: "A",
      date_time: "Data e ora"
    },
    feedback: {
      header: "Invia feedback",
      placeholders: [ "Seleziona il tipo di feedback", "Aggiungi una descrizione" ],
      types: [ "bug", "idea", "domanda", "altro" ],
      buttons: [ "Annulla", "Invia" ],
      issue_text: "Si è verificato un problema durante l'invio del tuo feedback. Riprova più tardi. Grazie!"
    },
    user_navigation: {
      no_actions_nav: {
	home: "Home",
	my_tribe: "La mia tribù",
	squads: 'I miei team',
	outlook_events: "Eventi di Outlook",
	google_events: "Eventi di Google",
	qr: "Check-in QR o walk-in",
	tracker: [ "Avvia giornata lavorativa,", "Termina giornata lavorativa," ],
	reservations: "Gestisci prenotazioni",
	releases: "Modifica assenze",
	who_is_arround: "Chi è nei dintorni",
	find_colleague: "Trova un collega",
	report_issue: "Segnala un problema",
	user_settings: "Impostazioni utente",
	help_center: "Centro assistenza"
      },
      actions_nav: {
	book_desk: "Prenota una scrivania",
	book_meeting_room: "Prenota una sala riunioni",
	add_new_release: "Aggiungi assenza"
      }
    },
    button: {
      ok: "OK",
      add: "Aggiungi",
      show: "Mostra",
      hide: "Nascondi",
      send: "Invia",
      save: "Salva",
      edit: "Modifica",
      more: "Altro",
      close: "Chiudi",
      email: "E-mail",
      login: 'Accedi',
      logout: 'Esci.',
      check_in: 'Check-in',
      submit: "Invia",
      delete: "Elimina",
      select: "Seleziona",
      cancel: "Annulla",
      upload: "Carica",
      remove: "Rimuovi",
      reopen: "Riapri",
      comment: "Commento",
      confirm: "Conferma",
      inverse: 'Inverso',
      refresh: "Aggiorna",
      continue: "Continua",
      download: "Scarica",
      show_all: "Mostra tutto",
      checked_in: "Check-in effettuato",
      select_all: 'Seleziona tutto',
      batch_edit: "Modifica in blocco",
      upload_image: "Carica immagine",
      remove_image: 'Rimuovi immagine',
      assign_me_one: "Assegnamene uno",
      back_to_dashboard: '< Torna alla Dashboard',
      cancel_reservation: "Annulla",
      check_availability: "Disponibilità",
      retutn_releases_list: "Torna all'elenco delle assenze",
      retutn_reservations_list: "Torna all'elenco delle prenotazioni",
      retutn_reservations_releases_events_list: [ "Torna a", "eventi" ]
    },
    release_reservation_text: {
      outlook: "Cambia l'ora nel calendario di Outlook",
      google: "Cambia l'ora nel calendario di Google"
    }
  },
  v2_shared_components: {
    calc: {
      sum: "Somma totale: ",
      count: "conteggio: ",
      price: "prezzo: "
    },
    tribeloo_asset_info: {
      user_info: "Assegnato a te",
      user_release_info: "Questa risorsa ti è stata assegnata. Prenotala se desideri utilizzarla.",
      user_booked_info: "Questa risorsa ti è stata assegnata ed è disponibile in qualsiasi momento per l'uso.",
      invited_users: "colleghi invitati e oggetto",
      time_slot: "Non disponibile oggi",
      buttons: {
	invite: 'Invita colleghi',
	book: 'Conferma prenotazione',
	update: 'Conferma modifiche',
	delete: 'Annulla prenotazione',
	edit: 'Modifica prenotazione'
      }
    },
    tribeloo_asset_list: {
      headers: {
	menu: "Strumenti Tribeloo",
	favorites: "Preferiti"
      },
      filter: {
	search: "Cerca",
	all: "Tutti",
	users_only: "Solo utenti",
	resources_only: "Solo risorse"
      },
      menu_items: {
	colleagues: {
	  subtitle: "Trova un collega",
	  description: "Collabora facilmente con i tuoi colleghi"
	},
	bookings: {
	  subtitle: "Le mie prenotazioni",
	  description: "Una panoramica di tutte le tue prenotazioni"
	},
	releases: {
	  subtitle: "Liberazioni",
	  description: "Libera la tua scrivania dedicata in modo che altri possano utilizzarla"
	},
	qr: {
	  subtitle: "Scanner QR",
	  description: "Prenota o effettua il check-in utilizzando lo scanner QR"
	}
      }
    },
    tribeloo_asset_list_item: {
      check_in: ["Check-in effettuato", "Check-in"]
    },
    tribeloo_asset_release_popper: {
      buttons: {
	create: "Crea liberazione",
	cancel: "Annulla liberazione"
      }
    },
    tribeloo_assets_popper: {
      title: "Risorse disponibili",
      show_all: "Tutti"
    },
    tribeloo_component_filter: {
      title: "Opzioni filtro",
      date_range: ["Intervallo di date", "Da", "A"],
      type: "Tipo di risorsa",
      location: "Luogo"
    },
    tribeloo_bookings_list: {
      subtitle: ['Trova colleghi', 'Le mie prenotazioni'],
      description: ['Cerca i colleghi per trovare le loro prenotazioni e ottimizzare la collaborazione', 'Una panoramica di tutte le tue prenotazioni. Gestisci tutte le tue prenotazioni in un unico posto.'],
      search: "risultati della ricerca.",
      not_found: "Nessun collega trovato."
    },
    tribeloo_camera: {
      camera_error_message: "Si prega di concedere l'accesso alla fotocamera",
      camera_not_found: "Nessuna fotocamera trovata."
    },
    tribeloo_date_picker: {
      max_selection_info: "Selezione massima di più giorni raggiunta",
      days_selected_text: "giorni selezionati",
      toggle_text_info: ["Seleziona più giorni", "Seleziona più giorni"]
    },
    tribeloo_download_image: {
      info_dialogue: "La tua immagine è troppo grande.\nSeleziona un'immagine con una dimensione inferiore a 4 MB."
    },
    tribeloo_edit_invites: {
      title: "Modifica invito alla prenotazione",
      subtitle: "Un'e-mail verrà inviata solo ai colleghi appena aggiunti.",
      buttons: {
	main_invite: "Invita colleghi",
	send_invite: ['Reinvia invito', 'Invia invito']
      },
      placeholder: "Inviti aggiornati"
    },
    tribeloo_favorites_list_item: {
      other_info: "Prenotazioni attive"
    },
    tribeloo_map_legend: {
      button: "Centra mappa",
      map_legend_title: "Legenda mappa",
      map_legend_items: {
	available: "Disponibile",
	confirm: "Necessita di conferma",
	not_for_user: "Non per l'utente",
	unavailable: "Non disponibile"
      }
    },
    tribeloo_qr_scanner: {
      title: "Scansiona codice QR",
      subtitle: "Posiziona il codice QR di fronte alla fotocamera per prenotare o fare il check-in.",
      error_message: "Errore durante la scansione del codice QR",
      processing_message: "Decodifica della scansione in corso"
    },
    tribeloo_releases_sidebar: {
      title_resources: "Le mie risorse",
      title_releases: "Le mie liberazioni",
      subtitle: "Liberazioni",
      description: "Imposta l'ora, la data e scegli la risorsa che desideri liberare.",
    },
    tribeloo_type_location_neighbourhood: {
      labels: {
	type: "Tipo di risorsa",
	site: "Sito",
	wing: "Ala",
	neighbourhoods: "Quartieri"
      }
    },
    tribeloo_upload_profile_pic: {
      title: "Carica immagine",
      subtitle: "Scegli una foto del profilo da mostrare sulla mappa",
      info_dialog_component: "La tua immagine è troppo grande.\nSeleziona un'immagine con una dimensione inferiore a 4 MB.",
      support_text: "Supporta i formati JPG o PNG",
      dd_text: "Trascina e rilascia l'immagine o",
      browse_text: "sfoglia",
      buttons: {
	save: "Salva immagine",
	upload: "Carica immagine",
	capture: "Scatta una foto usando la webcam",
      },
      img_alt: "Nuova foto profilo"
    },
    tribeloo_whoisaround: {
      title: "Chi è nei dintorni?"
    },
    tribeloo_more_settings: {
      title: "Più impostazioni",
      labels: {
	seats: "Posti",
	amenities: "Servizi",
	visitor: "Invita ospite"
      },
      toggles: {
	amenities: "Mostra solo con tutti i servizi",
	booking: "La prenotazione non è visibile agli altri"
      },
      placeholders: {
	visitor: "Email dell'ospite",
	amenities: "Nessun servizio selezionato"
      },
      info: "Più impostazioni non disponibili"
    },
    tribeloo_time_range: {
      labels: {
	select: "Selezione rapida",
	start: "Ora di inizio",
	end: "Ora di fine"
      },
      rangeOptions: {
	fullDay: 'Giornata intera',
	morning: 'Mattina',
	afternoon: 'Pomeriggio',
	customTime: 'Ora personalizzata'
      }
    },
    tribeloo_time_picker: {
      tooltip_error: "Formato ora non valido",
    },
    tribeloo_single_file_upload: {
      button_save: "Salva immagine ritagliata"
    },
    tribeloo_pop_up_confirmation: {
      titles: {
	cancel: "Annullamento prenotazione",
	edit: "Modifica prenotazione riuscita",
	invite: "Modifica invito alla prenotazione",
	booked: "Prenotazione riuscita!",
	options: "Opzioni di prenotazione opzionali",
	addSubject: "Aggiungi oggetto",
      },
      subtitles: {
	edit_booked: "Ti verrà inviata un'e-mail con le informazioni sulla tua prenotazione.",
	invite: "Un'e-mail verrà inviata solo ai colleghi appena aggiunti.",
	old: "Vecchia prenotazione",
	new: "Nuova prenotazione",
	cancel: "Una volta che una prenotazione viene annullata, non può essere annullata."
      },
      subjectInput: {
	saved: 'Oggetto salvato',
	placeholder: 'Nome oggetto'
      },
      input: ['Inviti aggiornati', 'Colleghi invitati'],
      buttons: {
	confirm: 'Conferma',
	main: "Invita colleghi",
	booKingSubjectInvitations: "Oggetto prenotazione e inviti",
	send: "Invia invito",
	update: "Aggiorna inviti",
	cancel: "Annulla prenotazione",
	nevermind: "Non importa",
	saveSubject: "Salva oggetto"
      }
    },
    tags_modal: {
      title: "tag",
      subtitle: "Breve spiegazione su come funzionano i tag",
      small_title: ['Suggerimenti', 'Tutti i tag'],
      colleagues: "colleghi",
      placeholder: "Cerca o aggiungi tag",
      add_button: ['Aggiungi', 'Aggiungi nuovo tag'],
      save_button: "Salva modifiche"
    },
    tribeloo_base_user_settings: {
      settings: "Impostazioni utente",
      tribe: "La mia tribù"
    },
    tribeloo_filter_tribe_members: {
      title: "Opzioni filtro",
      tag: "Tag",
      site: "Sito di partenza"
    },
    tribeloo_my_tribe: {
      description: "Tagga i colleghi per trovarli facilmente durante la creazione di una prenotazione e definisci i tuoi gruppi.",
      search: "Cerca"
    },
    tribeloo_tribe_member: {
      title: "Tag",
      not_found: "Nessun tag trovato",
      edit_button: "Modifica tag"
    }
  },
  v2_pages: {
    tribeloo_default_page_holder: {
      messages: {
	update_success: 'Prenotazione aggiornata con successo',
	update_failed: 'Impossibile aggiornare la prenotazione.',
	cancel_failed: "Impossibile annullare la liberazione",
	error408: "Vuoi forzare la prenotazione?"
      }
    },
    tribeloo_external_invites: {
      info: "Il tuo invito non è valido",
      button: "Vai a casa"
    }
  }
}

